exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-select-tree .el-select-dropdown__item{display:none}", ""]);

// exports
